import { Typography } from '@navi/web-ui/lib/primitives';
import { useNavigate } from 'react-router';
import APP_ROUTES from '@cp/src/layout/Routes';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { IAmeyoUtility } from '../AmeyoUtility/interfaces';
import { Roles } from '../auth/constants/AuthConstants';
import styles from './allocationServices.module.scss';
import AgentCircularIcon from '@cp/src/assets/icons/AgentCircularIcon';
import AgencyCircularIcon from '@cp/src/assets/icons/AgencyCircularIcon';
import { useMemo } from 'react';
import Allocation from '.';
import FieldAllocationIcon from '@cp/src/assets/icons/FieldAllocationIcon';
import CiuAllocationIcon from '@cp/src/assets/icons/CiuAllocationIcon';

const AllocationPage = () => {
  const navigate = useNavigate();
  const handleCardClick = (topath: IAmeyoUtility) => {
    navigate(topath.path);
  };
  const user = useSelector((state: RootState) => state.common?.userData);
  const featureFlags = useSelector((state: RootState) => state?.common?.featureFlags);
  const { allocateCaseToAgency = false, selfServeAllocationFeatureEnabled = false } =
    featureFlags || {};

  const isCiuAllocationEnabled = user?.roles?.includes(Roles.ROLE_ALLOCATION_EXPERIMENT);

  const cardData = useMemo(() => {
    return [
      {
        icon: <AgentCircularIcon />,
        text: 'Agents',
        onClick: () => handleCardClick(APP_ROUTES.AGENTS_ALLOCATION),
        isVisible: user?.roles?.includes(Roles.ROLE_ALLOCATIONS_ACCESS)
      },
      {
        icon: <AgencyCircularIcon />,
        text: 'Agencies',
        onClick: () => handleCardClick(APP_ROUTES.AGENCY_ALLOCATION),
        isVisible: allocateCaseToAgency
      },
      {
        icon: <FieldAllocationIcon />,
        text: 'Field Allocations',
        onClick: () => handleCardClick(APP_ROUTES.FIELD_ALLOCATIONS),
        isVisible: selfServeAllocationFeatureEnabled
      },
      {
        icon: <CiuAllocationIcon />,
        text: 'CIU',
        onClick: () => handleCardClick(APP_ROUTES.CIU_ALLOCATION),
        isVisible: isCiuAllocationEnabled
      }
    ];
  }, [user]);

  if (!allocateCaseToAgency) {
    return <Allocation />;
  }

  return (
    <div className={styles.container}>
      <Typography variant="h3" className={cx(styles.headerContainer, 'text-center !w-full')}>
        Allocation services
      </Typography>
      <Typography variant="h4" className={cx(styles.subHeaderContainer, '!w-full')}>
        For whom do you want to use this service?
      </Typography>
      <div className={styles.subContainer}>
        {cardData?.map(
          (card, text) =>
            card.isVisible && (
              <div key={text} className={styles.card} onClick={card.onClick}>
                {card.icon}
                <Typography variant="h4" className={styles.cardContent}>
                  {card.text}
                </Typography>
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default AllocationPage;
